import { useCallback, useEffect, useMemo, useState } from 'react';
import { Alert, Box, Button, Checkbox, FormControlLabel, Paper, TextField, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';



const Step3 = ({ onSubmit, onBack, quizz }) => {
  const [options, setOptions] = useState(quizz.options);
  const { choices } = quizz;


  useEffect(() => {
    // En fonction des choix, on initialise les options

    //Si au moins 2 entrées dans un choix
    if(quizz.choices.some(choice => choice.entries && choice.entries.length > 1)){
      setOptions({
        ...options,
        validate : true,
        multipleChoice : true,
        numberOfChoices : quizz.choices.length
      });
    }else{
      // On compte le nombre de "isCorrect" total
      const nbCorrect = quizz.choices.reduce((acc, current) => {
        current.entries.forEach(entry => {
          if(entry.isCorrect)
            acc++
        })

        return acc

      }, 0)
      setOptions({
        ...options,
        validate : false,
        multipleChoice : true,
        numberOfChoices : nbCorrect
      });
    }
}, [])

const noCorrectAnswerAlert = useMemo(() => {
  const isError = quizz.choices.some(choice => choice.entries.length > 1 && !choice.entries.find(e => e.isCorrect))

  const isE = quizz.choices.filter(choice => choice.entries.length === 1).every(choice => !choice.entries[0].isCorrect)

  if(quizz.choices.some(choice => choice.entries.length === 1))
    return isE

  return isError
  }, [quizz.choices])

  const handleCheckboxChange = (event) => {
    setOptions({
      ...options,
      [event.target.name]: event.target.checked,
    });
  };

  const handleInputChange = (event) => {
    setOptions({
      ...options,
      [event.target.name]: parseInt(event.target.value),
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({options});
  };

  const getInformations = useCallback(() => {
    if(quizz.choices.some(choice => choice.entries && choice.entries.length > 1)){
      if(options.validate && options.numberOfChoices === quizz.choices.length)
        return 'Règles standard'

      return 'Pour ce format de quiz, nous vous conseillons de définir le nombre de choix à '+quizz.choices.length+' et de cocher \'Valider les réponses manuellement\'.'

    }else{
      // On compte le nombre de "isCorrect" total
      const nbCorrect = quizz.choices.reduce((acc, current) => {
        current.entries.forEach(entry => {
          if(entry.isCorrect)
            acc++
        })

        return acc

      }, 0)
      if(!options.validate && options.numberOfChoices === nbCorrect)
        return 'Règles standard'

      return 'Pour ce format de quiz, nous vous conseillons de définir le nombre de choix à '+nbCorrect+' et de décocher \'Valider les réponses manuellement\'.'
    }
  }, [options.numberOfChoices, options.validate, quizz.choices])

  return (
    <Box sx={{ width: '100%', maxWidth: '500px', margin: 'auto' }}>

          <Box sx={{display: 'inline-flex', alignItems: 'center', padding:'1rem'}}>
            <Typography variant="h6" gutterBottom>
            Étape 3 : Règles du quiz
          </Typography>
          </Box>

    {noCorrectAnswerAlert && <Alert severity="warning">Il semble manquer des bonnes réponses, vérifier l'étape précédente et cocher la ou les bonne(s) réponse(s) du quiz.</Alert> }

    <br/>

      <Box sx={{ mb: 2 }}>
        <TextField
          disabled={!options.multipleChoice}
          label="Nombre de réponses souhaitées"
          variant="outlined"
          type={"number"}
          name="numberOfChoices"
          value={options.numberOfChoices}
          onChange={handleInputChange}
          inputProps={{
            min: 1,
            max: choices.length,
            step: 1,
          }}
          fullWidth
        />
      </Box>

      

      <Box sx={{ mb: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={options.validate}
              onChange={handleCheckboxChange}
              name="validate"
              color="primary"
            />
          }
          label="Valider les réponses manuellement"
        />
      </Box>

      <Paper sx={{p : 2, bottom : 0, background : 'rgb(250,250,250)', mb : 2, display:'flex', alignItems: 'center', justifyContent: 'center'}}>
        <InfoIcon sx={{padding: '5px'}} /><Typography variant='subtitle2' sx={{padding: '7px', marginBottom:'0'}}>{getInformations()}</Typography>
      </Paper>

      

      <Box sx={{ display: 'flex', justifyContent: 'center', padding:'1rem' }}>
        <Button variant="contained" onClick={onBack}>
          Retour
        </Button>
        <Button variant="contained" onClick={handleSubmit} sx={{ ml: 2 }}>
          Suivant
        </Button>
      </Box>
    </Box>
  );
};

export default Step3;